export const appsColumns = [{
  dataField: 'rank',
  text: 'Rank',
  sortable: false,
}, {
  dataField: 'free',
  text: 'Free',
  sortable: false,
}, {
  dataField: 'free_change',
  text: 'Change',
  sortable: false,
}, {
  dataField: 'paid',
  text: '$ Paid',
  sortable: false,
},{
  dataField: 'paid_change',
  text: 'Change',
  sortable: false,
}, {
  dataField: 'grossing',
  text: '$ Grossing',
  sortable: false,
}, {
  dataField: 'grossing_change',
  text: 'Change',
  sortable: false,
}];
